import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import moment from 'moment';

import { Breadcrumb, Card, Row, Skeleton, Button, Select } from 'antd';
import OneRowData from 'components/OneRowData';
import Table from 'components/Table';
import { Link } from 'react-router-dom';
import { permissionService } from 'shared/services';
import TncPreview from '../../components/TncPreview/TncPreview.component';

import allBillersRoute from '../../route';

import text from './TncDetail.page.translation';

import './TncDetail.style.less';
const { checkPermission } = permissionService;
const { Option } = Select;

class TncDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      lang: 'en',
    };
  }

  componentDidMount() {
    const tncId = this.props.match.params.id;
    this.props.getTncDetail(tncId);
  }

  renderBreadCrumb = () => (
    <div className="breadcrumb-wrapper">
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link to={allBillersRoute.TNC_LIST}>
            {this.props.intl.formatMessage(text.list)}
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          {this.props.intl.formatMessage(text.detail)}
        </Breadcrumb.Item>
      </Breadcrumb>
    </div>
  );

  renderLeftData = () => {
    const {
      detail,
      intl: { formatMessage },
    } = this.props;

    const listLeftData = [
      { label: formatMessage(text.data.id), value: get(detail, 'public_id') },
      {
        label: formatMessage(text.data.name),
        value: get(detail, 'name'),
      },
      {
        label: formatMessage(text.data.version),
        value: get(detail, 'latest_version.name'),
      },
    ];
    const listLeftSection = listLeftData.map(element => (
      <OneRowData key={element.label} data={element} />
    ));
    return (
      <Card.Grid className="card-grid-style minH210">
        <Skeleton
          active
          loading={this.props.loading}
          paragraph={{
            rows: 8,
            width: ['100%', '100%', '100%', '100%'],
          }}
          title={false}
        >
          {listLeftSection}
        </Skeleton>
      </Card.Grid>
    );
  };

  renderRightData = () => (
    <Card.Grid className="card-grid-style minH210">
      <Skeleton
        active
        loading={this.props.loading}
        paragraph={{
          rows: 8,
          width: ['100%', '100%', '100%', '100%'],
        }}
        title={false}
      >
        <Card
          type="inner"
          title={this.props.intl.formatMessage(text.data.preview)}
        >
          <div className="preview-section">
            <div style={{ fontSize: 16, marginBottom: 8 }}>
              {this.props.intl.formatMessage(text.data.preview)} Language
            </div>
            <Select
              size="large"
              style={{ width: '100%', marginBottom: 20 }}
              value={this.state.lang}
              onChange={lang => {
                this.setState({ lang });
              }}
            >
              <Option key="en" value="en">
                English
              </Option>
              <Option key="id" value="id">
                Bahasa
              </Option>
            </Select>
            <TncPreview
              htmlContent={get(this.props, `detail.content.${this.state.lang}`)}
            />
          </div>
        </Card>
      </Skeleton>
    </Card.Grid>
  );

  renderNoColumn = (t, r, index) => index + 1;

  renderVersion = (t, r, index) => (
    <span>
      {t}{' '}
      {index === 0 && (
        <span style={{ color: '#5ace70', fontSize: 14 }}>(Shown)</span>
      )}
    </span>
  );

  renderCretedAt = t => moment(t).format('DD/MM/YYYY');

  _getRowId = row => row.id;

  _tableColumns = () => [
    {
      title: this.props.intl.formatMessage(text.log.no),
      key: 'index',
      render: this.renderNoColumn,
      width: 80,
    },
    {
      title: this.props.intl.formatMessage(text.log.version),
      dataIndex: 'name',
      key: 'name',
      render: this.renderVersion,
    },
    {
      title: this.props.intl.formatMessage(text.log.created),
      dataIndex: 'created_at',
      key: 'created_at',
      render: this.renderCretedAt,
      width: 200,
    },
  ];

  renderLogVersion = () => (
    <div className="white-box-wrapper version-log">
      <span className="title">{this.props.intl.formatMessage(text.log)}</span>

      <Table
        bordered
        rowID={this._getRowId}
        rowKey={this._getRowId}
        columns={this._tableColumns()}
        dataSource={this.props.detail.version_history}
        pagination=""
        rowClass="striped-table"
        loadingValue={this.props.loading}
      />
    </div>
  );

  render() {
    return (
      <div className="main-content">
        {this.renderBreadCrumb()}

        <div className="white-box-wrapper tnc-detail">
          <span className="title">
            {this.props.intl.formatMessage(text.detail)}
          </span>
          <Card bordered={false}>
            <Row type="flex">
              {this.renderLeftData()}
              {this.renderRightData()}
            </Row>
          </Card>
          {checkPermission('Tnc:update', true) && (
            <Row className="btn-edit-wrapper">
              <Button
                type="primary"
                size="large"
                className="btn-edit"
                onClick={() => {
                  this.props.history.push(
                    allBillersRoute.TNC_EDIT.replace(
                      ':id',
                      this.props.detail.public_id,
                    ),
                  );
                }}
              >
                {this.props.intl.formatMessage(text.update)}
              </Button>
            </Row>
          )}
        </div>

        {this.renderLogVersion()}
      </div>
    );
  }
}

TncDetail.propTypes = {
  intl: PropTypes.object.isRequired,
  detail: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  getTncDetail: PropTypes.func,
  loading: PropTypes.bool,
};

export default TncDetail;
